import React from "react";
import PropTypes from "prop-types";
import { Table } from "components";
// import { Button } from "antd";
import { UNDERWRITING_REQUEST_COLS } from "constants/table-columns";

class UnderwritingJobTable extends React.Component {
    render() {
        return (
            <Table
                title={"Underwriting Jobs"}
                columns={UNDERWRITING_REQUEST_COLS
                    // .set("action", {
                    //     title: "Action",
                    //     dataIndex: "action",
                    //     key: "action",
                    //     render: (_, record) =>
                    //         record.current_status === 3 ? (
                    //             <Button
                    //                 type={"link"}
                    //                 onClick={() =>
                    //                     this.props.router(
                    //                         `/app/underwriting/jobs/${record.id}`
                    //                     )
                    //                 }
                    //             >
                    //                 View
                    //             </Button>
                    //         ) : null
                    // })
                }
                checkedCols={[]}
                showFilters={false}
                onFilter={this.props.onFilter}
                data={this.props.data && this.props.data.sort((a, b) => (a.id > b.id) ? -1 : 1)}
                keyFilter={this.props.keyFilter}
                showBulkDropdown={true}
                // bulkActionDropdown={this.BulkDropdown}
                showCsvBtn={true}
                showColumnSelector={false}
                showAssetsBtn={false}
                showTitle={true}
                fixedColsLeft={[]}
                loading={false}
                size={"middle"}
                editable={false}
                showFooter={true}
                pagination={{
                    current: this.props.currentPage,
                    showSizeChanger: true,
                    defaultPageSize: 20,
                    pageSizeOptions: ["10", "20", "50", "100"],
                    position: "bottom",
                    total: this.props.count,
                    onChange: (page, pageSize) =>
                        this.props.onPageChange(page, pageSize),
                    onShowSizeChange: this.props.onPageChange
                }}
            />
        );
    }
}

UnderwritingJobTable.propTypes = {
    keyFilter: PropTypes.string,
    count: PropTypes.number,
    data: PropTypes.object,
    onPageChange: PropTypes.func,
    currentPage: PropTypes.string,
    router: PropTypes.func,
    onFilter: PropTypes.func
};

export default UnderwritingJobTable;
